import React from 'react';
import { BoxProps, Flex } from '@chakra-ui/react';

interface ListSubheaderProps {
  onClick?: () => void;
  children?: React.ReactNode;
}

export const ListSubheader: React.FC<ListSubheaderProps & BoxProps> = ({
  children,
  onClick,
  ...rest
}) => (
  <Flex
    height="100%"
    width="100%"
    alignSelf="flex-end"
    alignItems="center"
    onClick={onClick}
    {...rest}
  >
    {children}
  </Flex>
);
